import type { MessagePayloadMap, Message } from '../TextParticles.types';
import {
  UPDATE_RENDERER_PROPS,
  PLAY,
  INITIALIZE,
  STOP,
  UPDATE_IMAGE,
  TERMINATE_INSTANCE,
  ANIMATION_FINISHED,
  INITIALIZED,
  SET_PREVIEW,
  PAUSE,
  ANIMATION_STOPPED,
  UPDATE_ANIMATION_STATE,
} from '../TextParticles.types';

export const getMainThreadMessages = (componentId: string) => ({
  getPlayMessage: (): Message<typeof PLAY> => ({
    type: PLAY,
    payload: undefined,
    componentId,
  }),
  getInitializeMessage: (
    payload: MessagePayloadMap[typeof INITIALIZE],
  ): Message<typeof INITIALIZE> => ({
    type: INITIALIZE,
    payload,
    componentId,
  }),
  getStopMessage: (): Message<typeof STOP> => ({
    type: STOP,
    componentId,
    payload: undefined,
  }),
  getPauseMessage: (): Message<typeof PAUSE> => ({
    type: PAUSE,
    componentId,
    payload: undefined,
  }),
  getUpdateImageMessage: (
    payload: MessagePayloadMap[typeof UPDATE_IMAGE],
  ): Message<typeof UPDATE_IMAGE> => ({
    type: UPDATE_IMAGE,
    payload,
    componentId,
  }),
  getTerminateInstanceMessage: (): Message<typeof TERMINATE_INSTANCE> => ({
    type: TERMINATE_INSTANCE,
    componentId,
    payload: undefined,
  }),
  getSetPreviewMessage: (): Message<typeof SET_PREVIEW> => ({
    type: SET_PREVIEW,
    componentId,
    payload: undefined,
  }),
  getUpdateRendererPropsMessage: (
    payload: MessagePayloadMap[typeof UPDATE_RENDERER_PROPS],
  ): Message<typeof UPDATE_RENDERER_PROPS> => ({
    type: UPDATE_RENDERER_PROPS,
    componentId,
    payload,
  }),
});

export const getWorkerMessages = (componentId: string) => ({
  getAnimationFinishedMessage: (): Message<typeof ANIMATION_FINISHED> => ({
    componentId,
    type: ANIMATION_FINISHED,
    payload: undefined,
  }),
  getInitializedMessage: (): Message<typeof INITIALIZED> => ({
    componentId,
    type: INITIALIZED,
    payload: undefined,
  }),
  getAnimationStoppedMessage: (): Message<typeof ANIMATION_STOPPED> => ({
    componentId,
    type: ANIMATION_STOPPED,
    payload: undefined,
  }),
  getUpdateAnimationStateMessage: (
    payload: MessagePayloadMap[typeof UPDATE_ANIMATION_STATE],
  ): Message<typeof UPDATE_ANIMATION_STATE> => ({
    componentId,
    type: UPDATE_ANIMATION_STATE,
    payload,
  }),
});
